import * as React from "react";
import { observer, inject } from "mobx-react";
import { observable } from "mobx";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Route, Link, Switch } from "react-router-dom";

@inject("store")
export default class SortToolbar extends React.Component {

    constructor(props) {
        super(props);

        this.handleFilterClick = this.handleFilterClick.bind(this);
    }
    handleFilterClick() {
        const navigation = this.props.store.navigation;
        navigation.openSort()
        //navigation.toolbarRouter.push("/sort");
    }

    render() {
        const navigation = this.props.store.navigation;
        const currentSortOption = navigation.getSortOptions().find(function (option) {
            return option.Value === navigation.sortOrder;
        });
        
        let  shortName = currentSortOption.Name.split(' ');
        shortName = shortName.length > 0 ? shortName[0].replace(',','') : currentSortOption.Name;
        
        return (
            
            <div className="col-6 mobile-sort-toolbar">
                <div className="filter-icon" onClick={() => {
                    this.handleFilterClick();
                }}>
                    {this.props.store.navigation.dictionary.Sort}&nbsp;<strong>{shortName}</strong>
                </div>
            </div>
        );
    }
}


